__turbopack_context__.v({
  "default": "Divider-module-scss-module__L30taq__default",
});
